module.exports = __webpack_public_path__ + "img/icons_6.19396b3e.svg";